import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { ElementRef, forwardRef, useId } from 'react';
import { Checkbox } from '../Checkbox/Checkbox';
import { TextFieldProps } from '../TextField/TextField';
import { Selector } from './Selector';

type SelectorProps = CheckboxPrimitive.CheckboxProps & {
  body: string;
  header?: string;
  disabled?: boolean;
  onChange?: CheckboxPrimitive.CheckboxProps['onCheckedChange'];
  freeText?: TextFieldProps;
  defaultChecked?: boolean;
  indeterminate?: boolean;
};

// eslint-disable-next-line react-x/no-forward-ref -- TODO: Wait! Don't change this file without seeing if you can remove this disable. It was added during a bulk version update, but fixing it would leave the park nicer than you found it.
export const MultiSelect = forwardRef<
  ElementRef<typeof CheckboxPrimitive.Root>,
  SelectorProps
>(
  (
    {
      disabled,
      value,
      required,
      header,
      body,
      freeText,
      onClick,
      onChange,
      ...props
    },
    forwardedRef,
  ) => {
    const id = useId();

    return (
      <Selector
        disabled={disabled}
        header={header}
        body={body}
        childId={id}
        freeText={freeText}
      >
        <div className="mb-auto mt-[3px]">
          <Checkbox
            {...props}
            id={id}
            disabled={disabled}
            onClick={disabled ? (e) => e.preventDefault() : onClick}
            onChange={onChange}
            ref={forwardedRef}
            parentHandlesInteraction
          />
        </div>
      </Selector>
    );
  },
);

MultiSelect.displayName = 'MultiSelect';
